// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.3333 4.9974V4.33073C12.3333 3.39731 12.3333 2.9306 12.1517 2.57408C11.9919 2.26047 11.7369 2.00551 11.4233 1.84572C11.0668 1.66406 10.6001 1.66406 9.66667 1.66406H8.33333C7.39991 1.66406 6.9332 1.66406 6.57668 1.84572C6.26308 2.00551 6.00811 2.26047 5.84832 2.57408C5.66667 2.9306 5.66667 3.39731 5.66667 4.33073V4.9974M7.33333 9.58073V13.7474M10.6667 9.58073V13.7474M1.5 4.9974H16.5M14.8333 4.9974V14.3307C14.8333 15.7309 14.8333 16.4309 14.5608 16.9657C14.3212 17.4361 13.9387 17.8186 13.4683 18.0582C12.9335 18.3307 12.2335 18.3307 10.8333 18.3307H7.16667C5.76654 18.3307 5.06647 18.3307 4.53169 18.0582C4.06129 17.8186 3.67883 17.4361 3.43915 16.9657C3.16667 16.4309 3.16667 15.7309 3.16667 14.3307V4.9974"
    />
  </svg>
);
const IconTrash = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconTrash;
